import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Notice from '@/components/Notice.vue';
import { format } from '@/utils/format';
import BigNumber from 'bignumber.js';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'UnstakeNotice',
  props: {
    amount: null
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'click'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  amount: BigNumber;
}

const { t } = useI18n();





const translationValue = computed(() => `${format(props.amount)} LP`);

const clickableTextTranslation = t(
  'portfolio.easyModeTranslations.common.notices.unstake.clickableText',
);
const restTextTranslation = computed(() =>
  t('portfolio.easyModeTranslations.common.notices.unstake.restText', {
    value: translationValue.value,
  }),
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Notice, { icon: "coinsOutlined" }, {
    "notice-text": _withCtx(() => [
      _createElementVNode("span", {
        class: "underline clickable mr-s1",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click')))
      }, _toDisplayString(_unref(clickableTextTranslation)), 1),
      _createElementVNode("span", null, _toDisplayString(_unref(restTextTranslation)), 1)
    ]),
    _: 1
  }))
}
}

})